module.exports = __webpack_public_path__ + "static/media/480.19eceebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-room/light/480.png
// module id = 2394
// module chunks = 2